import colors from '../../constants/js/colors.js';
export const sizeMap = {
  xsmall: {
    r: 6,
    strokeWidth: 3
  },
  small: {
    r: 10,
    strokeWidth: 4
  },
  medium: {
    r: 17,
    strokeWidth: 6
  },
  large: {
    r: 32,
    strokeWidth: 8
  }
};
export const colorMap = {
  blue: colors.majorBlue,
  white: colors.majorWhite
};